import React from "react";
import { FaCopy } from "react-icons/fa";
import { toast } from "react-toastify";

import { formatLocationPrefaceText, formatProductSheetsText, textBeforeProductSection } from "./serviceOrderProducts";

export function executionSummaries(obs) {
  return Array.isArray(obs.field_executions) ? obs.field_executions : [];
}

export function averageLines(summaryText) {
  return String(summaryText || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(
      (line) =>
        line.startsWith("Última abastecida") ||
        line.startsWith("Média das últimas") ||
        line.startsWith("Média total") ||
        line.startsWith("Hectares aplicados")
    );
}

export function orderCopyText(obs, t) {
  const parts = [];
  if (obs.operationName) parts.push(obs.operationName);
  const planSheet = formatProductSheetsText(obs.service_order_plan, t);
  let products = obs.products_used || "";
  const locationPreface = formatLocationPrefaceText({
    farmLabel: obs.service_farm_names || obs.site_farm_name,
    plotNames: obs.land_plot_names,
    preface: planSheet ? textBeforeProductSection(products) : products,
    translate: t,
  });
  if (planSheet) {
    products = [locationPreface, planSheet].filter(Boolean).join("\n\n");
  } else if (locationPreface) {
    products = locationPreface;
  }
  if (products) {
    parts.push(`Produtos a serem utilizados\n${products}`);
  }
  executionSummaries(obs).forEach((item) => {
    const who = [item.operatorName, item.machineName]
      .filter(Boolean)
      .join(" · ");
    if (who) parts.push(who);
    if (item.summaryText) parts.push(item.summaryText);
  });
  return parts.join("\n\n");
}

function copyWithExecCommand(value) {
  const area = document.createElement("textarea");
  area.value = value;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.top = "0";
  area.style.left = "0";
  area.style.width = "2em";
  area.style.height = "2em";
  area.style.padding = "0";
  area.style.border = "none";
  area.style.outline = "none";
  area.style.boxShadow = "none";
  area.style.background = "transparent";
  document.body.appendChild(area);
  const selection = document.getSelection();
  const previousRange =
    selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
  area.focus();
  area.select();
  let copied = false;
  try {
    copied = document.execCommand("copy");
  } catch (error) {
    copied = false;
  }
  document.body.removeChild(area);
  if (selection) {
    selection.removeAllRanges();
    if (previousRange) selection.addRange(previousRange);
  }
  return copied;
}

export async function copyPlainText(text, t) {
  const value = String(text || "").trim();
  if (!value) return false;
  let copied = copyWithExecCommand(value);
  if (!copied && navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      copied = true;
    } catch (error) {
      copied = false;
    }
  }
  if (copied) {
    toast.success(t("Texto copiado. Cole no grupo do WhatsApp."), {
      position: "bottom-right",
    });
    return true;
  }
  toast.error(t("Não foi possível copiar o texto."), {
    position: "bottom-right",
  });
  return false;
}

export async function copyOrderText(obs, t) {
  await copyPlainText(orderCopyText(obs, t), t);
}

export function ServiceOrderCalibrationAverages({
  obs,
  t,
  selecting = false,
  canSelect = false,
  onStartCopy,
  onConfirmCopy,
  onCancelCopy,
}) {
  const executions = executionSummaries(obs);
  const blocks = executions
    .map((item) => ({
      item,
      lines: averageLines(item.summaryText),
    }))
    .filter((block) => block.lines.length > 0);

  return (
    <div className="pending-schedules-card__products">
      {blocks.map((block, index) => (
        <div
          key={`${block.item.startedAt || index}`}
          style={{ marginBottom: "6px" }}
        >
          <strong>{t("Médias do check")}</strong>
          {block.item.operatorName || block.item.machineName
            ? ` · ${[block.item.operatorName, block.item.machineName]
                .filter(Boolean)
                .join(" · ")}`
            : ""}
          {block.lines.map((line) => (
            <div key={line}>{line}</div>
          ))}
        </div>
      ))}
      <div className="service-order-copy-actions">
        {selecting ? (
          <>
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={onConfirmCopy}
            >
              <FaCopy style={{ marginRight: "6px" }} />
              {t("Confirmar cópia")}
            </button>
            <button
              type="button"
              className="btn btn-default btn-sm"
              onClick={onCancelCopy}
            >
              {t("Cancelar")}
            </button>
          </>
        ) : (
          <button
            type="button"
            className="btn btn-default btn-sm"
            onClick={onStartCopy || (() => copyOrderText(obs, t))}
          >
            <FaCopy style={{ marginRight: "6px" }} />
            {canSelect ? t("Selecionar para copiar") : t("Copiar texto")}
          </button>
        )}
      </div>
    </div>
  );
}
